import { Box } from "@mui/material";
import NewDescription from "../../new/NewDescription";
import FormHelperText from "../FormHelperText";

const TypeDescription = ({
  updateValidationOnChange,
  dataCollection,
  field,
  errors,
  onPreventEnter,
}) => {
  function handleChange(description) {
    if (countTextCharacters(description) <= 0) {
      updateValidationOnChange(field.key, "");
    } else {
      updateValidationOnChange(field.key, description);
    }
  }

  function countTextCharacters(htmlString) {
    // Create a temporary div element to parse the HTML
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlString;

    // Extract the text content from the div element
    const textContent = tempDiv.textContent || tempDiv.innerText || "";

    // Remove extra whitespaces and line breaks, then count the characters
    const plainText = textContent.trim().replace(/\s+/g, " ");
    const charCount = plainText.length;

    return charCount;
  }

  return (
    <Box>
      <NewDescription
        label={field.label}
        onSave={handleChange}
        startHTML={dataCollection[field.key]}
        onPreventEnter={onPreventEnter}
      />
      <FormHelperText
        error={Boolean(errors[field.key])}
        helperText={errors[field.key]}
      />
    </Box>
  );
};
export default TypeDescription;
